<!-- KYMW7300 注文単位値引クーポン一覧 -->
<div class="contents-area">
  <div class="element-column">
    <div class="block-row">
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <!-- クーポン企画回 -->
            <label class="list-input-title">クーポン企画回</label>
            <div class="list-input-content">
              <app-text-input [(ngModel)]="model.couponIssueCatalog" [restrict]="'[0-9]'" [maxChars]="8" [halfOnly]="true"
                [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'7rem'" #txti_couponIssueCatalog
                (ngModelChange)="eventCouponIssueCatalog_CHANGEHandler()">
              </app-text-input>
            </div>
            <!-- クーポン注文コード -->
            <label class="list-input-title">クーポン注文コード</label>
            <div class="list-input-content">
              <app-text-input [(ngModel)]="model.couponOrderCd" [restrict]="'[0-9]'" [maxChars]="6" [halfOnly]="true"
                [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'7rem'"
                (ngModelChange)="eventCouponOrderCd_CHANGEHandler()">
              </app-text-input>
            </div>
          </div>
          <div class="column-list">
            <!-- 受付企画回 -->
            <label class="list-input-title">受付企画回</label>
            <div class="list-input-content">
              <app-text-input [(ngModel)]="model.receiptCatalog" [restrict]="'[0-9]'" [maxChars]="8" [halfOnly]="true"
                [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'7rem'"
                (ngModelChange)="eventReceiptCatalog_CHANGEHandler()">
              </app-text-input>
            </div>
            <!-- クーポン種別 -->
            <label class="list-input-title">クーポン種別</label>
            <div class="list-input-content">
              <app-code-combo-box [required]="false" [codeDiv]="'ctp213'" [labelField]="'codeValueName'"
                [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="model.couponCategory" [width]="'16rem'"
                (ngModelChange)="eventCouponCategory_CHANGEHandler()">
              </app-code-combo-box>
            </div>
          </div>
        </div>
        <div class="column-list">
          <!-- クーポン名（部分一致） -->
          <label class="list-input-title">クーポン名（部分一致）</label>
          <div class="list-input-content">
            <app-text-input [(ngModel)]="model.couponName" [restrict]="'[ -￮]'" [maxChars]="15" [fullOnly]="true"
              [displayCountField]="false" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'273px'"
              (ngModelChange)="eventCouponName_CHANGEHandler()">
            </app-text-input>
          </div>
        </div>
      </div>
    </div><!-- END div block-row -->
    <div style="width: calc(100vw - 300px);">
      <!-- button 検索 -->
      <button class="btn-secondary" #btn_Search (click)="search()" forcedEnabledMode="true" [tabindex]="0">検索</button>
      <!-- ページャー -->
      <div class="action-area">
        <app-pager [prevDisabled]="model.disabledPrev" [nextDisabled]="model.disabledNext" [totalNum]="model.totalNum"
          [startNum]="model.startDispNum" [endNum]="model.endDispNum" (prevHandler)="prev()" (nextHandler)="next()">
        </app-pager>
      </div>
      <!-- FlexGrid -->
      <wj-flex-grid #dtg_Main [itemsSource]="model.couponList" [headersVisibility]="'Column'"
        [selectionMode]="'Row'" horizontalScrollPolicy="on" verticalScrollPolicy="on" [allowSorting]="false"
        [allowDragging]="'Rows'" [autoScroll]="true" forcedEnabledMode="true">
        <!-- チェックボックス -->
        <wj-flex-grid-column [header]="' '" [width]="40" [minWidth]="5" [binding]="'check'" [align]="'center'" [isReadOnly]="true">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
              [tabindex]="-1" />
          </ng-template>
        </wj-flex-grid-column>
        <!-- クーポン商品連番 -->
        <wj-flex-grid-column [header]="'クーポン\n商品連番'" [width]="125" [binding]="'couponGoodsNo'"
          [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- クーポン注文コード -->
        <wj-flex-grid-column [header]="'クーポン\n注文コード'" [width]="90" [binding]="'couponOrderCd'"
          [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- クーポン名 -->
        <wj-flex-grid-column [header]="'クーポン名'" [width]="310" [binding]="'couponName'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- クーポン発行期間（開始） -->
        <wj-flex-grid-column [header]="'クーポン\n発行期間（開始）'" [width]="130"
          [binding]="'couponIssueCatalogStart'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- クーポン発行期間（終了） -->
        <wj-flex-grid-column [header]="'クーポン\n発行期間（終了）'" [width]="130"
          [binding]="'couponIssueCatalogEnd'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- 受付期間（開始） -->
        <wj-flex-grid-column [header]="'受付期間\n（開始）'" [width]="100"
          [binding]="'couponReceiptCatalogStart'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- 受付期間（終了） -->
        <wj-flex-grid-column [header]="'受付期間\n（終了）'" [width]="100"
          [binding]="'couponReceiptCatalogEnd'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- クーポン種別 -->
        <wj-flex-grid-column [header]="'クーポン種別'" [width]="220" [binding]="'dspCouponCategory'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- 通知有無区分 -->
        <wj-flex-grid-column [header]="'通知有無区分'" [width]="120" [binding]="'dspNoticeExistenceType'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- 通知方法区分（お届け明細） -->
        <wj-flex-grid-column [header]="'通知方法区分\n（お届け明細）'" [width]="120"
          [binding]="'dspNoticeMethodTypeItem'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
        <!-- 通知方法区分（メルマガ） -->
        <wj-flex-grid-column [header]="'通知方法区分\n（メルマガ）'" [width]="120"
          [binding]="'dspNoticeMethodTypeMail'" [isReadOnly]="true" [minWidth]="5">
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>


<footer class="footer-buttons">
  <!-- button 削除 -->
  <button id="btn-del" class="btn-tartiary warning" #btn_Del (click)="del()" [tabindex]="0">削除</button>
  <!-- button コピー -->
  <button id="btn-copy" class="btn-secondary" #btn_Copy (click)="copy()" [tabindex]="0">コピー</button>
  <!-- button 新規追加 -->
  <button id="btn-add" class="btn-primary" #btn_Add (click)="add()" [tabindex]="0">新規追加</button>
</footer>